import React from 'react';
import './ImageModal.css';

const ImageModal = ({ 
  isOpen, 
  selectedImage, 
  pictures, 
  currentIndex, 
  onClose, 
  onNext, 
  onPrev,
  title = "Device Image"
}) => {
  if (!isOpen || !selectedImage) return null;

  const hasMultiplePictures = pictures && pictures.length > 1;
  
  // Check if current image is from inference folder
  const isInferenceImage = selectedImage.url && selectedImage.url.includes('/inference/');
  
  if (isInferenceImage) {
    console.log(`🔵 Modal showing inference image: ${selectedImage.filename} (${selectedImage.url})`);
  }

  return (
    <div className="shared-image-modal-overlay" onClick={onClose}>
      <div className="shared-image-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="shared-image-modal-header">
          <h3>{title}</h3>
          <div className="modal-navigation">
            {hasMultiplePictures && (
              <span className="image-counter">
                {currentIndex + 1} of {pictures.length}
              </span>
            )}
          </div>
          <button 
            className="shared-image-modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>
        <div className="shared-image-modal-body">
          <img 
            src={selectedImage.url} 
            alt={title}
            className={`shared-image-modal-image ${isInferenceImage ? 'inference-image' : ''}`}
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <div className="shared-image-modal-fallback" style={{ display: 'none' }}>
            <p>Failed to load image</p>
          </div>
          <div className="image-meta">
            <p className="image-timestamp">
              Captured: {new Date(selectedImage.lastModified).toLocaleString()}
            </p>
            <p className="image-filename">
              File: {selectedImage.filename}
            </p>
            {isInferenceImage && (
              <p className="image-inference-badge">
                📊 Inference Image
              </p>
            )}
          </div>
        </div>
        {hasMultiplePictures && (
          <div className="shared-image-modal-controls">
            <button 
              className="modal-nav-button modal-prev"
              onClick={onPrev}
              aria-label="Previous image"
            >
              ‹ Previous
            </button>
            <button 
              className="modal-nav-button modal-next"
              onClick={onNext}
              aria-label="Next image"
            >
              Next ›
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageModal;